import { Link } from '@tanstack/react-router';
import { useContext, useMemo } from 'react';

import type { FindingOut } from '@/api/types';
import { RunCustomerSlugContext } from '@/components/RunCustomerSlugContext';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatCurrency } from '@/lib/format';
import { rollupFindingsByGlAccount } from '@/lib/glAccountRollup';

export function GlAccountsTab({ findings }: { findings: FindingOut[] }) {
  const customerSlug = useContext(RunCustomerSlugContext);
  const rows = useMemo(() => rollupFindingsByGlAccount(findings), [findings]);
  if (rows.length === 0) {
    return (
      <p className="text-sm text-brand-slate">
        No findings carry a GL account in their evidence.
      </p>
    );
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>GL account</TableHead>
          <TableHead className="text-right">Findings</TableHead>
          <TableHead className="text-right">Pending</TableHead>
          <TableHead className="text-right">Recovery $</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.glAccount}>
            <TableCell>
              {customerSlug ? (
                <Link
                  to="/customers/$slug"
                  params={{ slug: customerSlug }}
                  search={{ tab: 'accounts', account: row.glAccount }}
                  className="text-brand-royal underline-offset-4 hover:underline"
                  title="Open in the classification workbench"
                >
                  {row.glAccount}
                </Link>
              ) : (
                row.glAccount
              )}
            </TableCell>
            <TableCell className="text-right">{row.findingCount}</TableCell>
            <TableCell className="text-right">{row.pendingCount}</TableCell>
            <TableCell className="text-right">
              {formatCurrency(row.totalRecovery)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
